// Polyfill flat and flatMap for browsers not using those
import "array-flat-polyfill";

// Polyfill Object.hasOwn
// for browsers not supporting it
if (!Object.hasOwn) {
    Object.defineProperty(Object, "hasOwn", {
        value: function (obj: object, prop: string | symbol): boolean {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        },
        configurable: true,
        enumerable: false,
        writable: true,
    });
}

// Polyfill node global by setting it to window
declare global {
    interface Window {
        global: Window;
    }
    interface ObjectConstructor {
        hasOwn(obj: object, prop: string | symbol): boolean;
    }
}

// Polyfill js array .at method
if (!Array.prototype.at) {
    Array.prototype.at = function <T>(this: T[], index: number): T | undefined {
        // Convert the index to an integer
        index = Math.trunc(index) || 0;

        // Handle negative index
        if (index < 0) index += this.length;

        // Return undefined if index is out of bounds
        if (index < 0 || index >= this.length) return undefined;

        // Return the element at the calculated index
        return this[index];
    };
}
declare global {
    interface Set<T> {
        isEqualTo(set: Set<T>): boolean;
    }
}
if (!Set.prototype.isEqualTo) {
    Set.prototype.isEqualTo = function <T>(this: Set<T>, set: Set<T>): boolean {
        if (this.size !== set.size) return false;
        for (const value of this) {
            if (!set.has(value)) return false;
        }
        return true;
    };
}

window.global = window;
export {};
